export default {
  data() {
    return {
      sub4Options: [
        {text: 'no', value: null},
        {text: 'justlink', value: 'justlink'},
        {text: 'pwa', value: 'pwa'},
        {text: 'ios organica', value: 'ios organica'}
      ],
    }
  },
}



// WEBPACK FOOTER //
// ./resources/js/views/front/mixins/dataOptionsMixin.js